import { render, staticRenderFns } from "./AccordionObjectivesList.vue?vue&type=template&id=120d613c&scoped=true"
import script from "./AccordionObjectivesList.vue?vue&type=script&lang=js"
export * from "./AccordionObjectivesList.vue?vue&type=script&lang=js"
import style0 from "./AccordionObjectivesList.vue?vue&type=style&index=0&id=120d613c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120d613c",
  null
  
)

export default component.exports